// Generic type guard for checking if a string is a member of a string enum.
export const isEnumValue = <E extends string>(
  value: string,
  enumArg: Record<string, E>,
): value is E => {
  return Object.values(enumArg).includes(value as E);
};

// A utility type for asserting that the provided generic parameter is literal true.
// If anything other than true is provided, it will not compile.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export type AssertTrue<T extends true> = void;

// Returns true if the two provided types have bi-directional compatibility.
export type IsBiDiCompatible<A, B> = A extends B ? (B extends A ? true : false) : false;
